import React from 'react';
import ReactDOM from 'react-dom';
import { WeaLocaleProvider } from "ecCom";
import { WeaTable } from "ecCom";
import { getEcCom, getAntd } from '../../../util/convert';
import { CONFORM_RULE } from '../../../constants/type';
import './index.less';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import cloneDeep from 'lodash/cloneDeep';
import base from '../../../util/base';
const getLabel = WeaLocaleProvider.getLabel;
@inject('conformRuleStore')
@observer
export default class ConformRuleDialog extends React.Component {


 varTemp = {
  btns: []
  }
  state = {
    visible: true
  }
  componentDidMount() {
    const { isFromCheckResult = false,conformRuleStore:{getCheckResult} } = this.props;
    const { commonParam: { nodeid, requestid } } = base.globalStore;
    if(isFromCheckResult) {
      getCheckResult({isReset: 1, nodeid:nodeid , requestid:requestid, ...this.props.formParams, needConformCheck: 0 });
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({visible: true});
  }


  getHeader = () => {
    const { status, title } = this.props.conformRuleStore;
    const { isFromCheckResult = false } = this.props;
      return (
      <p className='top-word'>
        {status ? title : getLabel(533549,'正在检测，请稍候') + '...'} 
      </p>
      )
  }
  
  reformData = datas => {
    let endDatas = cloneDeep(toJS(datas));
    endDatas.map(item => {
      if(item.key == 'status') {
        item.render = ( r, obj, i) => {
          let dom = [];
          switch(obj.status) {
            case 0: { 
              dom = [
                <div className="content-wrap">
                  <img src="/images/ecology9/workflow/loading.gif"/>
                </div>,
              ]
            }; break; //对比中
            case 1: {
              dom.push(<div className="content-wrap">
                <i className="icon-coms02-icon-Completion pass" title={getLabel(533550,'校验通过')}/>
              </div>)
            }; break; //对比成功
            case 2: {
              dom.push(<div className="content-wrap">
                <i className="icon-coms-Clear failed" title={getLabel(533551, '不满足规则时禁止提交流程')}/>
              </div>)
            }; break; //对比失败，禁止提交
            case 3: {
              dom.push(<div className="content-wrap">
                <i className="icon-coms02-Warning-01 remind" title={getLabel(533552,'不满足规则时仅提醒')}/>
              </div>)
            }; break; //对比失败，仅提醒
          }
          return dom;
        }
      }
    });
    return endDatas;
  }
  getContent = () => {
    const { WeaTable } = getEcCom();
    const { conformRuleInfo: {columns, datas } } = this.props.conformRuleStore;
    let newColumns = [];
    if(columns) {
     newColumns = this.reformData(toJS(columns));
    }
    return ( 
      <WeaTable
        columns={newColumns}
        dataSource={toJS(datas)}
        pagination={false} 
        scroll={{y: 360}}
      />
    )
  }
  onSubmit = () => {
    const { conformRuleSubmitEvent, conformRuleCancelEvent,setHasCheckedConformRule } = this.props.conformRuleStore;
    typeof conformRuleSubmitEvent == 'function' && conformRuleSubmitEvent();
    base.globalStore.changeSubmitParam({needConformCheck: '0'});
    conformRuleCancelEvent();
    setHasCheckedConformRule(true);
    this.setState({ visible: false});
  }
  onCancel = () => {
    const { conformRuleCancelEvent } = this.props.conformRuleStore;
    conformRuleCancelEvent();
    this.setState({ visible: false});
  }
  breakCheck = () => {
    const { conformRuleStopRequestEvent, conformRuleCancelEvent } = this.props.conformRuleStore;
    conformRuleStopRequestEvent();
    this.onCancel();
  }
  getButtons = () => {
    const { Button } = getAntd();
    const { conformRuleInfo:{ result }} = this.props.conformRuleStore;
    let buttons = [];
    if(!this.props.isFromCheckResult) {
      if(!result.end) { //检测中
        buttons = [
          <Button onClick={this.breakCheck}>{getLabel(31129,'取消')}</Button>
        ]
      } else if(result.allPass) {
        buttons = [
          <Button onClick={this.breakCheck} disabled={true}>{getLabel(31129,'取消')}</Button>
        ]
      } else if(result.processType == 0) { //禁止提交
        buttons = [
          <Button type='primary' onClick={this.onCancel}>{getLabel(533553,'修改表单')}</Button>
        ];
      } else if (result.processType == 1) { //允许提交
        buttons = [
          <Button type='primary' onClick={this.onSubmit}>{getLabel(533554,'继续提交流程')}</Button>,
          <Button onClick={this.onCancel}>{getLabel(31129,'取消')}</Button>
        ]
  
      }
    } else {
      buttons = [
        <Button type="primary" onClick={this.setDialogHidden}>{getLabel(826,`确定`)}</Button>
      ]
    }
    return buttons;
  }
  setDialogHidden = () => {
    ReactDOM.unmountComponentAtNode(document.getElementById('conform-rule-container'))
    base.globalStore.changeSubmitParam({needConformCheck: '0'});
    this.setState({visible: false});
  }
  render() {
    const { WeaDialog } = getEcCom();
    const { conformDialogvisible } = this.props.conformRuleStore;
    const { isFromCheckResult = false } = this.props;
    const { visible } = this.state;
    this.varTemp.btns = this.getButtons();
    return(
      <WeaDialog
        className='conform-rule-prompt'
        title={!isFromCheckResult ? getLabel(513004, '信息确认') : getLabel(533555,'节点字段校验结果')}
        icon='icon-coms02-Warning'
        iconBgcolor='#F2A945'
        buttons={this.varTemp.btns}
        visible={visible}
        style={{width:"563px", height: '447px'}}
        onCancel={!isFromCheckResult ? this.breakCheck : this.setDialogHidden}
        layout={document.getElementById('container') || document.body}
      >
        {this.getHeader()}
        {this.getContent()}
      </WeaDialog>
    )
  }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/components/dialog/conform-rule/index.js